// Adapted from https://github.com/plouc/nivo/blob/master/website/src/theming/nivo.js
// Should be added to theme prop of any nivo chart
// https://github.com/plouc/nivo/issues/308

// eslint-disable-next-line
export function NivoTheme(theme: any): any {
  return {
    crosshair: {
      line: {
        stroke: "#ccd7e2",
      },
    },
    axis: {
      domain: {
        line: {
          strokeWidth: 0,
          stroke: theme.palette.base.border[1],
        },
      },
      ticks: {
        line: {
          strokeWidth: 1,
          stroke: theme.palette.base.border[1],
        },
        text: {
          fill: theme.palette.base.text[2],
          fontSize: 12,
          fontWeight: 400,
        },
      },
      legend: {
        text: {
          fill: theme.palette.base.text[2],
          fontSize: 13,
          fontWeight: 500,
        },
      },
    },
    grid: {
      line: {
        stroke: theme.palette.base.border[1],
      },
    },
    legends: {
      text: {
        fontSize: 12,
        fill: theme.palette.base.text[2],
      },
    },
    labels: {
      text: {
        fill: "#ffffff",
        fontSize: 12,
        fontWeight: 500,
      },
    },
    dots: {
      text: {
        fill: theme.palette.base.text[2],
        fontSize: 12,
      },
    },
  }
}
